import { windowUtils } from '@packages/domain/utils/windowUtils/windowUtils';

export const BrowserRepository = {
  getFlywireSubdomain() {
    const host = windowUtils.getHost();
    const match = host.match(/(flywire.*)/) || [];

    return match[0];
  },
};
